"use client";

import { useEffect, useRef } from "react";

const units = [
  {
    id: "academia-code",
    name: "Unidade Academia Code",
    address: "Av. Sertório, 8000 — 3º Andar do Centelar",
    neighborhood: "Sarandi – Porto Alegre – RS",
    whatsapp: "5551999991111",
    mapSrc: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3452.8!2d-51.1435!3d-29.9760!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x951977b0e5a47e7b%3A0x0!2zMjnCsDU4JzMzLjYiUyA1McKwMDgnMzYuNiJX!5e0!3m2!1spt-BR!2sbr!4v1700000000001",
    hours: "Seg–Sex: 7h às 21h · Sáb: 8h às 13h",
  },
  {
    id: "cristo-redentor",
    name: "Unidade Cristo Redentor",
    address: "Av. Assis Brasil, 2474 — Sala 201/202",
    neighborhood: "Cristo Redentor – Porto Alegre – RS",
    whatsapp: "5551999992222",
    mapSrc: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3452.5!2d-51.1560!3d-29.9750!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x951977b0e5a47e7b%3A0x1!2zMjnCsDU4JzMwLjAiUyA1McKwMDknMjEuNiJX!5e0!3m2!1spt-BR!2sbr!4v1700000000002",
    hours: "Seg–Sex: 7h às 21h · Sáb: 8h às 13h",
  },
  {
    id: "jardim-leopoldina",
    name: "Unidade Jardim Leopoldina",
    address: "Rua Prof.ª Amy Herve Ramires, 167 — Loja 08-J",
    neighborhood: "Jardim Dona Leopoldina – Porto Alegre – RS",
    whatsapp: "5551999993333",
    mapSrc: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3453.0!2d-51.1400!3d-30.0200!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x951977b0e5a47e7b%3A0x2!2zMzDCsDAxJzEyLjAiUyA1McKwMDgnMjQuMCJX!5e0!3m2!1spt-BR!2sbr!4v1700000000003",
    hours: "Seg–Sex: 7h às 21h · Sáb: 8h às 13h",
  },
];

export default function UnitsContact() {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.remove("reveal-hidden");
            e.target.classList.add("reveal-active");
          }
        });
      },
      { threshold: 0.06 }
    );
    ref?.current?.querySelectorAll(".reveal-hidden")?.forEach((el) => observer?.observe(el));
    return () => observer?.disconnect();
  }, []);

  return (
    <section className="py-32 md:py-44 px-6 md:px-10" style={{ background: 'var(--cream-dark)' }} ref={ref}>
      <div className="max-w-8xl mx-auto">
        <div className="text-center mb-20">
          <span className="reveal-hidden subheading mb-5 block">Onde Estamos</span>
          <h2 className="reveal-hidden reveal-delay-1 font-serif text-forest leading-tight"
            style={{ fontSize: 'clamp(2.2rem, 5vw, 3.5rem)' }}>
            Nossas <span className="italic font-light text-sage">unidades</span>
          </h2>
        </div>

        <div className="space-y-24">
          {units?.map((unit, i) => (
            <div
              key={unit?.id}
              className={`reveal-hidden reveal-delay-${(i % 3) + 1} grid grid-cols-1 lg:grid-cols-2 gap-10 items-stretch`}
            >
              {/* Map */}
              <div className={`rounded-4xl overflow-hidden min-h-72 ${i % 2 === 1 ? "lg:order-2" : ""}`}
                style={{ boxShadow: '0 8px 40px rgba(26,61,26,0.1)' }}>
                <iframe
                  src={unit?.mapSrc}
                  width="100%"
                  height="100%"
                  style={{ minHeight: "360px", border: 0 }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title={`Mapa da ${unit?.name}`}
                  className="w-full h-full"
                />
              </div>

              {/* Info */}
              <div
                className={`bg-white rounded-4xl p-10 md:p-12 flex flex-col justify-between ${i % 2 === 1 ? "lg:order-1" : ""}`}
                style={{ boxShadow: '0 4px 24px rgba(26,61,26,0.06)', border: '1px solid rgba(232,226,214,0.5)' }}
              >
                <div>
                  <span className="subheading mb-4 block">Unidade {i + 1}</span>
                  <h3 className="font-serif mb-8" style={{ fontSize: '1.8rem', color: 'var(--forest)' }}>{unit?.name}</h3>

                  <div className="space-y-5 mb-10">
                    <div className="flex items-start gap-4">
                      <div className="w-10 h-10 rounded-2xl flex items-center justify-center flex-shrink-0 mt-0.5"
                        style={{ background: 'var(--sage-pale)' }}>
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" style={{ color: 'var(--forest)' }}>
                          <path d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"/>
                          <path d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"/>
                        </svg>
                      </div>
                      <div>
                        <p className="text-sm font-medium" style={{ color: 'var(--charcoal)' }}>{unit?.address}</p>
                        <p className="text-sm" style={{ color: 'var(--stone)' }}>{unit?.neighborhood}</p>
                      </div>
                    </div>

                    <div className="flex items-start gap-4">
                      <div className="w-10 h-10 rounded-2xl flex items-center justify-center flex-shrink-0 mt-0.5"
                        style={{ background: 'var(--sage-pale)' }}>
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" style={{ color: 'var(--forest)' }}>
                          <circle cx="12" cy="12" r="10"/>
                          <polyline points="12 6 12 12 16 14"/>
                        </svg>
                      </div>
                      <p className="text-sm" style={{ color: 'var(--stone)' }}>{unit?.hours}</p>
                    </div>
                  </div>
                </div>

                <div>
                  <div className="divider-gold mb-8" />
                  <div className="flex gap-3">
                    <a
                      href={`https://wa.me/${unit?.whatsapp}?text=Olá! Gostaria de informações sobre a ${unit?.name}.`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="flex-1 flex items-center justify-center gap-2 text-white rounded-full py-4 text-sm font-semibold transition-all duration-300 hover:opacity-90"
                      style={{ background: '#25D366' }}
                    >
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
                      </svg>
                      WhatsApp
                    </a>
                    <a
                      href={`https://maps.google.com/?q=${encodeURIComponent(unit?.address + ', ' + unit?.neighborhood)}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="flex-1 flex items-center justify-center gap-2 rounded-full py-4 text-sm font-semibold transition-all duration-300 hover:bg-forest hover:text-cream"
                      style={{ border: '1.5px solid var(--forest)', color: 'var(--forest)' }}
                    >
                      Ver no mapa
                    </a>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}